module.exports = __webpack_public_path__ + "img/saveImg.548ca398.svg";